import Utils from "../lib/Utils";

export default class PageHome {
    constructor() {
       //
    }
}